import car from '~/assets/icons/car.svg';
import chest from '~/assets/icons/chest.svg';
import donate from '~/assets/icons/currency_donate.svg';
import discount from '~/assets/icons/discount.svg';
import surpriseBox from '~/assets/icons/surprise_box.svg';
import tshirt from '~/assets/icons/tshirt.svg';
import userRound from '~/assets/icons/user_round.svg';

export enum ShopMenu {
	Discount = 'discount',
	Cases = 'cases',
	Kits = 'kits',
	Donate = 'donate',
	Vehicle = 'vehicle',
	Clothes = 'clothes',
	Player = 'player',
}

export const shopMenuNames = {
	[ShopMenu.Discount]: 'Акции и предложения',
	[ShopMenu.Cases]: 'Кейсы',
	[ShopMenu.Kits]: 'Наборы',
	[ShopMenu.Donate]: 'Пополнение',
	[ShopMenu.Clothes]: 'Одежда',
	[ShopMenu.Player]: 'Персонаж',
	[ShopMenu.Vehicle]: 'Транспорт',
};

export const shopMenuIcons = {
	[ShopMenu.Discount]: discount,
	[ShopMenu.Cases]: chest,
	[ShopMenu.Kits]: surpriseBox,
	[ShopMenu.Donate]: donate,
	[ShopMenu.Clothes]: tshirt,
	[ShopMenu.Player]: userRound,
	[ShopMenu.Vehicle]: car,
};
